import React from 'react';
export var PlusIcon = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.height, height = _c === void 0 ? 14 : _c, _d = _a.color, color = _d === void 0 ? '#ffffff' : _d;
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 14 14", fill: color },
        React.createElement("path", { d: "M6,0l0,6l-6,0l0,2l6,0l0,6l2,0l0,-6l6,0l0,-2l-6,0l0,-6l-2,0Z" })));
};
